import { styled } from '@mui/material';

import { Tooltip, Typography } from '@app-velocity/ui';

export type SummaryHeaderProps = {
  cardLabel: string;
  title: string;
  subtitle?: string;
};

const Header = styled('header')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  minWidth: 0,
}));

const StyledCardLabel = styled(Typography)({
  fontSize: 16,
  lineHeight: 1.5,
  fontWeight: 700,
});

const StyledTitle = styled(Typography)({
  fontSize: 14,
  lineHeight: 1.5,
  fontWeight: 500,
  minWidth: 0,
  flex: 1,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const StyledSubtitle = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,
  flex: 1,
});

export const SummaryHeader = ({
  cardLabel,
  title,
  subtitle,
}: SummaryHeaderProps) => {
  return (
    <Header>
      <StyledCardLabel>{cardLabel}</StyledCardLabel>
      <Tooltip title={title}>
        <StyledTitle>{title}</StyledTitle>
      </Tooltip>
      <Tooltip title={subtitle}>
        <StyledSubtitle>{subtitle}</StyledSubtitle>
      </Tooltip>
    </Header>
  );
};
